import './bottom-sheet-menu.scss';

import { useState } from 'react';
import { useSelector } from 'react-redux';

import BookletsLink from '@/resources/components/navbar/BookletsLink';
import CategoryLink from '@/resources/components/navbar/CategoryLink';
import UserIdentity from '@/resources/components/UserIdentity';
import { useDevice } from '@/resources/hooks/useDevice';
import { useNavbarContext } from '@/resources/hooks/useNavbarContext';
import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { ApplicationState } from '@/store';
import { IOrder } from '@/store/ducks/order/types';

import BottomSheet from '../../../bottomSheet/BottomSheet';
import { DiscountsButton } from '../../DiscountsButton';
import { DiscountContent } from './DiscountContent/DiscountContent';
import { Identify } from './Identify';

export default function BottomSheetMenu({ open, onClose }: { open: boolean; onClose: () => void }) {
  const selectOrder = useSelector<ApplicationState, IOrder | null>((state) => state.order.data);

  const { configs, order } = useWebContext();
  const { device } = useDevice();
  const { categories, booklets } = useNavbarContext();
  const [openDiscounts, setOpenDiscounts] = useState<boolean>(false);

  const textColor = useTextColor(
    device === 'desktop' ? configs.navbar_footer_color : configs.color,
  );

  const usefullOrder = order || selectOrder;

  return (
    <BottomSheet open={open} onClose={onClose} configColor={configs.color} fontColor={textColor}>
      <DiscountContent onShow={openDiscounts} onClose={() => setOpenDiscounts(false)} />
      {usefullOrder?.client.type !== 3 && <UserIdentity client={usefullOrder?.client} />}

      <ul className="menu-link-wrapper">
        {usefullOrder?.client.type === 3 && <Identify />}
        {configs.has_discount_button && (
          <li style={{ listStyle: 'none', padding: 0, margin: 0 }} className="w-100">
            <DiscountsButton
              style={{
                backgroundColor: configs.discount_button_color,
                color: useTextColor(configs.discount_button_color),
              }}
              className="dropdown-item mobile"
              label={configs.discount_button_label}
              onClick={() => setOpenDiscounts(true)}
            />
          </li>
        )}
        {configs.has_booklet && booklets.length > 0 && (
          <BookletsLink
            color={configs.color}
            onClose={onClose}
            style={{ backgroundColor: 'transparent' }}
            className="dropdown-item dropdown-item-navbar"
          />
        )}
        {categories?.length ? (
          <>
            <li className="dropdown-item pb-0" style={{ pointerEvents: 'none', color: 'gray' }}>
              Categorias
            </li>
            {categories?.map((category) => (
              <CategoryLink
                color="#333"
                isInDropdown
                onClose={onClose}
                category={category}
                className="dropdown-item dropdown-item-navbar"
                key={`actived-${category.type}-navbar-${category.id}`}
                type={category.type}
              />
            ))}
          </>
        ) : null}
      </ul>
    </BottomSheet>
  );
}
